import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Quote } from 'lucide-react';

const PaperSummary = ({ summary }) => {
  if (!summary) {
    return (
      <div className="text-center py-12 text-slate-400">
        <FileText className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>Summary not available</p>
      </div>
    );
  }

  // Split summary into paragraphs for better readability
  const paragraphs = summary.split('\n').filter(p => p.trim());

  return (
    <div className="space-y-6" data-testid="paper-summary">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 rounded-xl bg-slate-800">
          <FileText className="w-5 h-5 text-teal-400" />
        </div>
        <h2 className="text-xl font-heading font-bold text-white">Paper Summary</h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative"
      >
        {/* Quote Icon */}
        <div className="absolute -top-2 -left-2 w-12 h-12 rounded-2xl bg-teal-400/10 flex items-center justify-center">
          <Quote className="w-6 h-6 text-teal-400 rotate-180" />
        </div>

        {/* Summary Content */}
        <div className="p-8 pl-12 rounded-2xl bg-gradient-to-br from-slate-800/50 to-slate-800/30 border border-slate-700/50">
          <div className="space-y-4">
            {paragraphs.map((paragraph, index) => (
              <motion.p
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="text-slate-300 leading-relaxed font-body"
              >
                {paragraph}
              </motion.p>
            ))}
          </div>

          {/* Word Count */}
          <div className="mt-6 pt-4 border-t border-slate-700/50 flex items-center justify-between">
            <span className="text-xs text-slate-500">
              {summary.split(/\s+/).length} words
            </span>
            <span className="text-xs text-slate-500">
              AI-generated summary
            </span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PaperSummary;
